export const login = async () => {
  return {
    userID: 'recz1l2OxmsdDt8j4',
    name: 'Zena Kelley',
    username: 'velvetround',
    image:
      'https://res.cloudinary.com/jmarellanes/image/upload/v1737183243/PaNurkvwWQbjSY04El4cFh5HlMeTygKOYDuUs7_07-8_yu1joe.jpg',
  };
};
